import React from 'react';
import '../styles/global.css';

const LegalDocs = () => {
    return (
        <div className="legal-docs" style={{ padding: '20px', color: 'var(--text-primary)', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
            <h1 style={{ color: 'var(--accent)', marginBottom: '30px' }}>Política de Privacidad y Términos de Uso</h1>

            <section style={{ marginBottom: '30px' }}>
                <p>Vortex EXANI-II respeta la privacidad de sus usuarios y se compromete a proteger sus datos personales. Al utilizar la plataforma, aceptas los siguientes términos y condiciones.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: 'var(--accent)', fontSize: '1.4rem', borderBottom: '1px solid #444', paddingBottom: '10px' }}>Política de Privacidad</h2>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>1. Datos que recopilamos</h3>
                    <p><strong>Identificadores de usuario:</strong> Utilizamos la cuenta de Google para procesos de autenticación y vinculación de dispositivos.</p>
                    <p><strong>Acceso al micrófono:</strong> Se utiliza únicamente para funciones de reconocimiento de voz. No se almacenan ni comparten grabaciones de audio en nuestros servidores.</p>
                    <p><strong>Almacenamiento:</strong> Se requiere para guardar configuraciones, preferencias y el progreso del usuario localmente o en la base de datos segura de Cloud.</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>2. Uso de la información</h3>
                    <p>Los datos se utilizan exclusivamente para el correcto funcionamiento de la app y la mejora de la experiencia del usuario. No compartimos información personal con terceros, salvo los servicios técnicos necesarios para el funcionamiento (por ejemplo, Firebase/Google).</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>3. Derechos del usuario</h3>
                    <p>Puedes solicitar el acceso, rectificación o eliminación de tus datos en cualquier momento escribiendo a: <a href="mailto:vortexadmision@gmail.com" style={{ color: 'var(--accent)' }}>vortexadmision@gmail.com</a>.</p>
                </div>
            </section>

            <section style={{ marginBottom: '40px' }}>
                <h2 style={{ color: 'var(--accent)', fontSize: '1.4rem', borderBottom: '1px solid #444', paddingBottom: '10px' }}>Términos y Condiciones de Uso</h2>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>1. Introducción</h3>
                    <p>Estos Términos y Condiciones rigen el uso de Vortex EXANI-II. Al acceder a la plataforma, el usuario acepta la vinculación de su dispositivo con su cuenta de Google y se compromete a cumplir con estos Términos.</p>
                    <p style={{ fontStyle: 'italic', opacity: 0.8 }}>El usuario será el único responsable de los posibles problemas legales derivados del mal uso de la información contenida en la aplicación.</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>2. Contenidos</h3>
                    <p>La plataforma incluye preparación académica basada en el temario oficial del examen EXANI-II de Ceneval y los lineamientos de admisión de universidades públicas y autónomas de México que utilizan el EXANI-II, así como materiales de ámbito literario, matemático y de inglés. Algunos módulos contienen reactivos elaborados con fines pedagógicos con formato oficial de 3 opciones (A, B, C).</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>3. Limitación de responsabilidad</h3>
                    <p>Vortex EXANI-II no garantiza la exactitud o exhaustividad de la información proporcionada. La plataforma no está afiliada, asociada ni respaldada por Ceneval ni por las instituciones educativas que utilizan el EXANI-II.</p>
                </div>

                <div style={{ marginTop: '20px' }}>
                    <h3 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>4. Propiedad intelectual</h3>
                    <p>Los derechos de propiedad intelectual sobre el diseño, código y elementos originales son propiedad exclusiva del equipo desarrollador.</p>
                </div>
            </section>

            <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px', borderTop: '1px solid #444', opacity: 0.6, fontSize: '0.8rem' }}>
                © {new Date().getFullYear()} Vortex EXANI-II. Todos los derechos reservados.
            </div>
        </div>
    );
};

export default LegalDocs;
